import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9fa3c158"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex items-center gap-5"
};
const _hoisted_2 = {
  class: "input box"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "neural-network-container"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "input-node"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "output-node"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pointer-events-none absolute inset-0"
}, null, -1));
const _hoisted_9 = {
  class: "output box"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  key: 1,
  class: "result"
};
import { onMounted, ref, watch } from 'vue';
import { CurvyPath } from 'svg-dom-arrows';
import IconSelector from './IconSelector.vue';
export default {
  __name: 'GraphicalReasoningItem',
  props: /*#__PURE__*/_mergeModels({
    editMode: {
      type: Boolean,
      default: false
    }
  }, {
    "input": {
      type: Array,
      default: () => []
    },
    "inputModifiers": {},
    "output": {
      type: Array
    },
    "outputModifiers": {},
    "neurons": {
      type: Array,
      default: () => []
    },
    "neuronsModifiers": {}
  }),
  emits: ["update:input", "update:output", "update:neurons"],
  setup(__props) {
    const neuralNetwork = ref(null);
    const input = _useModel(__props, 'input');
    const output = _useModel(__props, 'output');
    const neurons = _useModel(__props, 'neurons');
    let paths = [];
    const props = __props;
    watch(neurons, newVal => {
      console.log(newVal);
      drawNeurons();
    });
    onMounted(() => {
      drawNeurons();
    });
    const drawNeurons = async () => {
      console.log('drawNeurons', neurons.value);
      const neuralNetworkDom = neuralNetwork.value;
      const inputNode = neuralNetworkDom.querySelector('.input-node');
      const outputNode = neuralNetworkDom.querySelector('.output-node');
      paths.forEach(path => {
        path.release();
        console.log(path);
      });
      paths = [];
      neurons.value.forEach((neuron, index) => {
        console.log('drawNeurons forEach', neuron, index, neurons.value.length);
        if (index === 0) {
          paths.push(new CurvyPath({
            start: {
              element: inputNode,
              position: {
                top: 0,
                left: 0
              }
            },
            end: {
              element: neuralNetworkDom.querySelector(`.neuron:nth-child(${neuron})`),
              position: {
                top: 0,
                left: 0
              }
            },
            style: 'stroke:black;stroke-width:1;fill:transparent',
            appendTo: neuralNetworkDom.querySelector('.pointer-events-none')
          }));
        }
        paths.push(new CurvyPath({
          start: {
            element: neuralNetworkDom.querySelector(`.neuron:nth-child(${neuron})`),
            position: {
              top: 0,
              left: 0
            }
          },
          end: {
            element: index === neurons.value.length - 1 ? outputNode : neuralNetworkDom.querySelector(`.neuron:nth-child(${neurons.value[index + 1]})`),
            position: {
              top: 0,
              left: 0
            }
          },
          style: 'stroke:black;stroke-width:1;fill:transparent',
          appendTo: neuralNetworkDom.querySelector('.pointer-events-none')
        }));
      });
    };
    const handleSelectInput = (index, icon) => {
      console.log(index, icon, 'handleSelectInput');
      input.value = input.value.map((item, i) => i === index ? icon : item);
    };
    const handleSelectOutput = (index, icon) => {
      console.log(index, icon, 'handleSelectOutput');
      output.value = output.value.map((item, i) => i === index ? icon : item);
    };

    // watch(input, (newVal) => {
    //   console.log('update:input', newVal)
    // })

    const handleSelectNeuron = neuron => {
      if (!props.editMode) {
        return;
      }
      neurons.value = neurons.value.includes(neuron) ? neurons.value.filter(item => item !== neuron) : [...neurons.value, neuron];
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "w-8 h-8 flex items-center justify-center",
          key: index
        }, [__props.editMode ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 0,
          placement: "bottom",
          title: "选择图案",
          width: "440",
          trigger: "click"
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_button, {
            class: "p-0 w-8 h-8"
          }, {
            default: _withCtx(() => [item ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item,
              alt: "icon",
              class: "w-5 h-5 object-contain"
            }, null, 8, _hoisted_3)) : _createCommentVNode("", true)]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createVNode(IconSelector, {
            onSelect: $event => handleSelectInput(index, $event)
          }, null, 8, ["onSelect"])]),
          _: 2
        }, 1024)) : item ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: item,
          alt: "icon",
          class: "w-5 h-5 object-contain"
        }, null, 8, _hoisted_4)) : _createCommentVNode("", true)]);
      }), 128))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "neural-network",
        ref_key: "neuralNetwork",
        ref: neuralNetwork
      }, [_createElementVNode("div", {
        class: _normalizeClass(`cursor-pointer neuron ${neurons.value.includes(1) ? 'active' : ''}`),
        style: {
          "top": "10%",
          "left": "50%"
        },
        onClick: _cache[0] || (_cache[0] = $event => handleSelectNeuron(1))
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(`cursor-pointer neuron ${neurons.value.includes(2) ? 'active' : ''}`),
        style: {
          "top": "40%",
          "left": "90%"
        },
        onClick: _cache[1] || (_cache[1] = $event => handleSelectNeuron(2))
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(`cursor-pointer neuron ${neurons.value.includes(3) ? 'active' : ''}`),
        style: {
          "top": "90%",
          "left": "75%"
        },
        onClick: _cache[2] || (_cache[2] = $event => handleSelectNeuron(3))
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(`cursor-pointer neuron ${neurons.value.includes(4) ? 'active' : ''}`),
        style: {
          "top": "90%",
          "left": "25%"
        },
        onClick: _cache[3] || (_cache[3] = $event => handleSelectNeuron(4))
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(`cursor-pointer neuron ${neurons.value.includes(5) ? 'active' : ''}`),
        style: {
          "top": "40%",
          "left": "10%"
        },
        onClick: _cache[4] || (_cache[4] = $event => handleSelectNeuron(5))
      }, null, 2), _hoisted_6, _hoisted_7, _hoisted_8], 512)]), _createElementVNode("div", _hoisted_9, [output.value && output.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(output.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "w-8 h-8 flex items-center justify-center",
          key: index
        }, [__props.editMode ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 0,
          placement: "bottom",
          title: "选择图案",
          width: "440",
          trigger: "click"
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_button, {
            class: "p-0 w-8 h-8"
          }, {
            default: _withCtx(() => [item ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item,
              alt: "icon",
              class: "w-5 h-5 object-contain"
            }, null, 8, _hoisted_10)) : _createCommentVNode("", true)]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createVNode(IconSelector, {
            onSelect: $event => handleSelectOutput(index, $event)
          }, null, 8, ["onSelect"])]),
          _: 2
        }, 1024)) : item ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: item,
          alt: "icon",
          class: "w-5 h-5 object-contain"
        }, null, 8, _hoisted_11)) : _createCommentVNode("", true)]);
      }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_12, "?"))])]);
    };
  }
};